import { translations as ptBR } from './pt-BR';
import { translations as en } from './en';
import { translations as es } from './es';

export const translations = {
  'pt-BR': ptBR,
  'en': en,
  'es': es
};

export type TranslationKey = keyof typeof ptBR;